/* eslint-disable eqeqeq */
/* eslint-disable complexity */
// Generated from /src/shared/components/internal/Filter/serialization/SearchSyntax.g4 by ANTLR 4.9.3
// jshint ignore: start
import antlr4 from 'antlr4';

import SearchSyntaxVisitor from './SearchSyntaxVisitor.js';

const serializedATN = [
  '\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786',
  '\u5964\u0003\u0019\u00b1\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004',
  '\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t',
  '\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004',
  '\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010',
  '\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013',
  '\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017',
  '\t\u0017\u0003\u0002\u0007\u00020\n\u0002\f\u0002\u000e\u00023\u000b',
  '\u0002\u0003\u0002\u0003\u0002\u0006\u00027\n\u0002\r\u0002\u000e\u0002',
  '8\u0003\u0002\u0007\u0002<\n\u0002\f\u0002\u000e\u0002?\u000b\u0002',
  '\u0005\u0002A\n\u0002\u0003\u0002\u0007\u0002D\n\u0002\f\u0002\u000e',
  '\u0002G\u000b\u0002\u0003\u0002\u0003\u0002\u0003\u0003\u0005\u0003',
  'L\n\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0005\u0003',
  'R\n\u0003\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004',
  '\u0005\u0004Y\n\u0004\u0003\u0005\u0003\u0005\u0003\u0006\u0003\u0006',
  '\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0007\u0003\u0007\u0003\u0007',
  '\u0003\b\u0003\b\u0003\b\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003',
  '\t\u0007\tn\n\t\f\t\u000e\tq\u000b\t\u0003\t\u0007\tt\n\t\f\t\u000e',
  '\tw\u000b\t\u0005\ty\n\t\u0003\t\u0003\t\u0003\n\u0003\n\u0003\n\u0005',
  '\n\u0080\n\n\u0003\u000b\u0003\u000b\u0003\u000b\u0003\u000b\u0003\f',
  '\u0003\f\u0003\f\u0003\f\u0003\f\u0005\f\u008b\n\f\u0003\r\u0003\r\u0003',
  '\r\u0003\r\u0005\r\u0091\n\r\u0003\u000e\u0003\u000e\u0007\u000e\u0095',
  '\n\u000e\f\u000e\u000e\u000e\u0098\u000b\u000e\u0003\u000f\u0003\u000f',
  '\u0005\u000f\u009c\n\u000f\u0003\u0010\u0003\u0010\u0005\u0010\u00a0',
  '\n\u0010\u0003\u0011\u0003\u0011\u0003\u0012\u0003\u0012\u0003\u0012',
  '\u0003\u0013\u0003\u0013\u0003\u0014\u0003\u0014\u0003\u0015\u0003\u0015',
  '\u0003\u0016\u0003\u0016\u0003\u0017\u0003\u0017\u0003\u0017\u0002\u0002',
  '\u0018\u0002\u0004\u0006\b\n\f\u000e\u0010\u0012\u0014\u0016\u0018\u001a',
  '\u001c\u001e "$&(*,\u0002\u0003\u0004\u0002\b\b\f\r\u0002\u00b6\u0002',
  '1\u0003\u0002\u0002\u0002\u0004K\u0003\u0002\u0002\u0002\u0006X\u0003',
  '\u0002\u0002\u0002\bZ\u0003\u0002\u0002\u0002\n\\\u0003\u0002\u0002',
  '\u0002\fa\u0003\u0002\u0002\u0002\u000ed\u0003\u0002\u0002\u0002\u0010',
  'g\u0003\u0002\u0002\u0002\u0012\u007f\u0003\u0002\u0002\u0002\u0014',
  '\u0081\u0003\u0002\u0002\u0002\u0016\u008a\u0003\u0002\u0002\u0002\u0018',
  '\u0090\u0003\u0002\u0002\u0002\u001a\u0092\u0003\u0002\u0002\u0002\u001c',
  '\u009b\u0003\u0002\u0002\u0002\u001e\u009d\u0003\u0002\u0002\u0002 ',
  '\u00a1\u0003\u0002\u0002\u0002"\u00a3\u0003\u0002\u0002\u0002$\u00a6',
  '\u0003\u0002\u0002\u0002&\u00a8\u0003\u0002\u0002\u0002(\u00aa\u0003',
  '\u0002\u0002\u0002*\u00ac\u0003\u0002\u0002\u0002,\u00ae\u0003\u0002',
  '\u0002\u0002.0\u0007\u0019\u0002\u0002/.\u0003\u0002\u0002\u000203\u0003',
  '\u0002\u0002\u00021/\u0003\u0002\u0002\u000212\u0003\u0002\u0002\u0002',
  '2@\u0003\u0002\u0002\u000231\u0003\u0002\u0002\u00024=\u0005\u0004\u0003',
  '\u000257\u0007\u0019\u0002\u000265\u0003\u0002\u0002\u000278\u0003\u0002',
  '\u0002\u000286\u0003\u0002\u0002\u000289\u0003\u0002\u0002\u00029:\u0003',
  '\u0002\u0002\u0002:<\u0005\u0004\u0003\u0002;6\u0003\u0002\u0002\u0002',
  '<?\u0003\u0002\u0002\u0002=;\u0003\u0002\u0002\u0002=>\u0003\u0002\u0002',
  '\u0002>A\u0003\u0002\u0002\u0002?=\u0003\u0002\u0002\u0002@4\u0003\u0002',
  '\u0002\u0002@A\u0003\u0002\u0002\u0002AE\u0003\u0002\u0002\u0002BD\u0007',
  '\u0019\u0002\u0002CB\u0003\u0002\u0002\u0002DG\u0003\u0002\u0002\u0002',
  'EC\u0003\u0002\u0002\u0002EF\u0003\u0002\u0002\u0002FH\u0003\u0002\u0002',
  '\u0002GE\u0003\u0002\u0002\u0002HI\u0007\u0002\u0002\u0003I\u0003\u0003',
  '\u0002\u0002\u0002JL\u0007\u0003\u0002\u0002KJ\u0003\u0002\u0002\u0002',
  'KL\u0003\u0002\u0002\u0002LQ\u0003\u0002\u0002\u0002MR\u0005\u0006\u0004',
  '\u0002NR\u0005(\u0015\u0002OR\u0005*\u0016\u0002PR\u0005,\u0017\u0002',
  'QM\u0003\u0002\u0002\u0002QN\u0003\u0002\u0002\u0002QO\u0003\u0002\u0002',
  '\u0002QP\u0003\u0002\u0002\u0002R\u0005\u0003\u0002\u0002\u0002SY\u0005',
  '\n\u0006\u0002TY\u0005\f\u0007\u0002UY\u0005\u0014\u000b\u0002VY\u0005',
  '\u000e\b\u0002WY\u0005\u0010\t\u0002XS\u0003\u0002\u0002\u0002XT\u0003',
  '\u0002\u0002\u0002XU\u0003\u0002\u0002\u0002XV\u0003\u0002\u0002\u0002',
  'XW\u0003\u0002\u0002\u0002Y\u0007\u0003\u0002\u0002\u0002Z[\u0007\u000b',
  '\u0002\u0002[\t\u0003\u0002\u0002\u0002\\]\u0005\b\u0005\u0002]^\u0005',
  '\u0018\r\u0002^_\u0007\u0011\u0002\u0002_`\u0005\u0018\r\u0002`\u000b',
  '\u0003\u0002\u0002\u0002ab\u0005\b\u0005\u0002bc\u0005\u0016\f\u0002',
  'c\r\u0003\u0002\u0002\u0002de\u0005\b\u0005\u0002ef\u0007\u0007\u0002',
  '\u0002f\u000f\u0003\u0002\u0002\u0002gh\u0005\b\u0005\u0002hi\u0005',
  '*\u0016\u0002ix\u0007\u0004\u0002\u0002ju\u0005\u0012\n\u0002ko\u0007',
  '\u0006\u0002\u0002ln\u0007\u0019\u0002\u0002ml\u0003\u0002\u0002\u0002',
  'nq\u0003\u0002\u0002\u0002om\u0003\u0002\u0002\u0002op\u0003\u0002\u0002',
  '\u0002pr\u0003\u0002\u0002\u0002qo\u0003\u0002\u0002\u0002rt\u0005\u0012',
  '\n\u0002sk\u0003\u0002\u0002\u0002tw\u0003\u0002\u0002\u0002us\u0003',
  '\u0002\u0002\u0002uv\u0003\u0002\u0002\u0002vy\u0003\u0002\u0002\u0002',
  'wu\u0003\u0002\u0002\u0002xj\u0003\u0002\u0002\u0002xy\u0003\u0002\u0002',
  '\u0002yz\u0003\u0002\u0002\u0002z{\u0007\u0005\u0002\u0002{\u0011\u0003',
  '\u0002\u0002\u0002|\u0080\u0005(\u0015\u0002}\u0080\u0005*\u0016\u0002',
  '~\u0080\u0005,\u0017\u0002\u007f|\u0003\u0002\u0002\u0002\u007f}\u0003',
  '\u0002\u0002\u0002\u007f~\u0003\u0002\u0002\u0002\u0080\u0013\u0003',
  '\u0002\u0002\u0002\u0081\u0082\u0005\b\u0005\u0002\u0082\u0083\u0007',
  '\u0010\u0002\u0002\u0083\u0084\u0005\u0018\r\u0002\u0084\u0015\u0003',
  '\u0002\u0002\u0002\u0085\u008b\u0005\u001e\u0010\u0002\u0086\u008b\u0005',
  '&\u0014\u0002\u0087\u008b\u0005*\u0016\u0002\u0088\u008b\u0005(\u0015',
  '\u0002\u0089\u008b\u0005,\u0017\u0002\u008a\u0085\u0003\u0002\u0002',
  '\u0002\u008a\u0086\u0003\u0002\u0002\u0002\u008a\u0087\u0003\u0002\u0002',
  '\u0002\u008a\u0088\u0003\u0002\u0002\u0002\u008a\u0089\u0003\u0002\u0002',
  '\u0002\u008b\u0017\u0003\u0002\u0002\u0002\u008c\u0091\u0005\u001e\u0010',
  '\u0002\u008d\u0091\u0005\u001a\u000e\u0002\u008e\u0091\u0005&\u0014',
  '\u0002\u008f\u0091\u0005(\u0015\u0002\u0090\u008c\u0003\u0002\u0002',
  '\u0002\u0090\u008d\u0003\u0002\u0002\u0002\u0090\u008e\u0003\u0002\u0002',
  '\u0002\u0090\u008f\u0003\u0002\u0002\u0002\u0091\u0019\u0003\u0002\u0002',
  '\u0002\u0092\u0096\u0005 \u0011\u0002\u0093\u0095\u0005\u001c\u000f',
  '\u0002\u0094\u0093\u0003\u0002\u0002\u0002\u0095\u0098\u0003\u0002\u0002',
  '\u0002\u0096\u0094\u0003\u0002\u0002\u0002\u0096\u0097\u0003\u0002\u0002',
  '\u0002\u0097\u001b\u0003\u0002\u0002\u0002\u0098\u0096\u0003\u0002\u0002',
  '\u0002\u0099\u009c\u0005"\u0012\u0002\u009a\u009c\u0005$\u0013\u0002',
  '\u009b\u0099\u0003\u0002\u0002\u0002\u009b\u009a\u0003\u0002\u0002\u0002',
  '\u009c\u001d\u0003\u0002\u0002\u0002\u009d\u009f\u0007\f\u0002\u0002',
  '\u009e\u00a0\u0007\u000f\u0002\u0002\u009f\u009e\u0003\u0002\u0002\u0002',
  '\u009f\u00a0\u0003\u0002\u0002\u0002\u00a0\u001f\u0003\u0002\u0002\u0002',
  '\u00a1\u00a2\t\u0002\u0002\u0002\u00a2!\u0003\u0002\u0002\u0002\u00a3',
  '\u00a4\u0007\u000e\u0002\u0002\u00a4\u00a5\u0007\n\u0002\u0002\u00a5',
  '#\u0003\u0002\u0002\u0002\u00a6\u00a7\u0007\t\u0002\u0002\u00a7%\u0003',
  "\u0002\u0002\u0002\u00a8\u00a9\u0007\u0012\u0002\u0002\u00a9'\u0003",
  '\u0002\u0002\u0002\u00aa\u00ab\u0007\u0015\u0002\u0002\u00ab)\u0003',
  '\u0002\u0002\u0002\u00ac\u00ad\u0007\u0017\u0002\u0002\u00ad+\u0003',
  '\u0002\u0002\u0002\u00ae\u00af\u0007\u0016\u0002\u0002\u00af-\u0003',
  '\u0002\u0002\u0002\u001318=@EKQXoux\u007f\u008a\u0090\u0096\u009b\u009f',
].join('');

const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map(
  (ds, index) => new antlr4.dfa.DFA(ds, index)
);

const sharedContextCache = new antlr4.PredictionContextCache();

export class SearchSyntaxParser extends antlr4.Parser {
  static grammarFileName = 'SearchSyntax.g4';
  static literalNames = [
    null,
    "'-'",
    "'('",
    "')'",
    "','",
    "'null'",
    "'NOW'",
    null,
    null,
    null,
    null,
    null,
    "'/'",
    null,
    null,
    "'..'",
    null,
    null,
    null,
    null,
    null,
    null,
    "':'",
  ];

  static symbolicNames = [
    null,
    'NEGATION',
    'OPEN_PAR',
    'CLOSE_PAR',
    'COMMA',
    'NULL',
    'DATETIME_FN',
    'DATETIME_MATH',
    'DATETIME_UNIT',
    'FIELD_MATCH',
    'DATE',
    'DATETIME',
    'DATETIME_ROUNDER',
    'TIMEZONE',
    'COMPARATOR',
    'RANGE_OP',
    'NUMBER',
    'DECIMAL',
    'INTEGER',
    'STRING',
    'IP',
    'WORD',
    'MATCH_OP',
    'WS',
  ];

  static ruleNames = [
    'query',
    'expression',
    'field',
    'fieldMatch',
    'fieldMatchRange',
    'fieldMatchValue',
    'fieldMatchNull',
    'fieldMatchFunction',
    'fieldMatchFunctionArg',
    'fieldComparison',
    'value',
    'comparable',
    'dateTimeExpr',
    'dateTimeOperation',
    'date',
    'dateTime',
    'dateTimeRound',
    'dateTimeMath',
    'number',
    'string',
    'word',
    'ip',
  ];

  constructor(input) {
    super(input);
    this._interp = new antlr4.atn.ParserATNSimulator(
      this,
      atn,
      decisionsToDFA,
      sharedContextCache
    );
    this.ruleNames = SearchSyntaxParser.ruleNames;
    this.literalNames = SearchSyntaxParser.literalNames;
    this.symbolicNames = SearchSyntaxParser.symbolicNames;
  }

  get atn() {
    return atn;
  }

  query() {
    const localctx = new QueryContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, SearchSyntaxParser.RULE_query);
    let _la = 0; // Token type
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 47;
      this._errHandler.sync(this);
      let _alt = this._interp.adaptivePredict(this._input, 0, this._ctx);
      while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER) {
        if (_alt === 1) {
          this.state = 44;
          this.match(SearchSyntaxParser.WS);
        }
        this.state = 49;
        this._errHandler.sync(this);
        _alt = this._interp.adaptivePredict(this._input, 0, this._ctx);
      }

      this.state = 62;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
      if (
        (_la & ~0x1f) == 0 &&
        ((1 << _la) &
          ((1 << SearchSyntaxParser.NEGATION) |
            (1 << SearchSyntaxParser.FIELD_MATCH) |
            (1 << SearchSyntaxParser.STRING) |
            (1 << SearchSyntaxParser.IP) |
            (1 << SearchSyntaxParser.WORD))) !==
          0
      ) {
        this.state = 50;
        this.expression();
        this.state = 59;
        this._errHandler.sync(this);
        let _alt = this._interp.adaptivePredict(this._input, 2, this._ctx);
        while (_alt != 2 && _alt != antlr4.atn.ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            this.state = 52;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
              this.state = 51;
              this.match(SearchSyntaxParser.WS);
              this.state = 54;
              this._errHandler.sync(this);
              _la = this._input.LA(1);
            } while (_la === SearchSyntaxParser.WS);
            this.state = 56;
            this.expression();
          }
          this.state = 61;
          this._errHandler.sync(this);
          _alt = this._interp.adaptivePredict(this._input, 2, this._ctx);
        }
      }

      this.state = 67;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
      while (_la === SearchSyntaxParser.WS) {
        this.state = 64;
        this.match(SearchSyntaxParser.WS);
        this.state = 69;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
      }
      this.state = 70;
      this.match(SearchSyntaxParser.EOF);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  expression() {
    const localctx = new ExpressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 2, SearchSyntaxParser.RULE_expression);
    let _la = 0; // Token type
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 73;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
      if (_la === SearchSyntaxParser.NEGATION) {
        this.state = 72;
        this.match(SearchSyntaxParser.NEGATION);
      }

      this.state = 79;
      this._errHandler.sync(this);
      switch (this._input.LA(1)) {
        case SearchSyntaxParser.FIELD_MATCH:
          this.state = 75;
          this.field();
          break;
        case SearchSyntaxParser.STRING:
          this.state = 76;
          this.string();
          break;
        case SearchSyntaxParser.WORD:
          this.state = 77;
          this.word();
          break;
        case SearchSyntaxParser.IP:
          this.state = 78;
          this.ip();
          break;
        default:
          throw new antlr4.error.NoViableAltException(this);
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  field() {
    const localctx = new FieldContext(this, this._ctx, this.state);
    this.enterRule(localctx, 4, SearchSyntaxParser.RULE_field);
    try {
      this.state = 86;
      this._errHandler.sync(this);
      const la_ = this._interp.adaptivePredict(this._input, 7, this._ctx);
      switch (la_) {
        case 1:
          this.enterOuterAlt(localctx, 1);
          this.state = 81;
          this.fieldMatchRange();
          break;

        case 2:
          this.enterOuterAlt(localctx, 2);
          this.state = 82;
          this.fieldMatchValue();
          break;

        case 3:
          this.enterOuterAlt(localctx, 3);
          this.state = 83;
          this.fieldComparison();
          break;

        case 4:
          this.enterOuterAlt(localctx, 4);
          this.state = 84;
          this.fieldMatchNull();
          break;

        case 5:
          this.enterOuterAlt(localctx, 5);
          this.state = 85;
          this.fieldMatchFunction();
          break;
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  fieldMatch() {
    const localctx = new FieldMatchContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, SearchSyntaxParser.RULE_fieldMatch);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 88;
      this.match(SearchSyntaxParser.FIELD_MATCH);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  fieldMatchRange() {
    const localctx = new FieldMatchRangeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 8, SearchSyntaxParser.RULE_fieldMatchRange);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 90;
      this.fieldMatch();
      this.state = 91;
      this.comparable();
      this.state = 92;
      this.match(SearchSyntaxParser.RANGE_OP);
      this.state = 93;
      this.comparable();
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  fieldMatchValue() {
    const localctx = new FieldMatchValueContext(this, this._ctx, this.state);
    this.enterRule(localctx, 10, SearchSyntaxParser.RULE_fieldMatchValue);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 95;
      this.fieldMatch();
      this.state = 96;
      this.value();
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  fieldMatchNull() {
    const localctx = new FieldMatchNullContext(this, this._ctx, this.state);
    this.enterRule(localctx, 12, SearchSyntaxParser.RULE_fieldMatchNull);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 98;
      this.fieldMatch();
      this.state = 99;
      this.match(SearchSyntaxParser.NULL);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  fieldMatchFunction() {
    const localctx = new FieldMatchFunctionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 14, SearchSyntaxParser.RULE_fieldMatchFunction);
    let _la = 0; // Token type
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 101;
      this.fieldMatch();
      this.state = 102;
      localctx.functionName = this.word();
      this.state = 103;
      this.match(SearchSyntaxParser.OPEN_PAR);
      this.state = 118;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
      if (
        (_la & ~0x1f) == 0 &&
        ((1 << _la) &
          ((1 << SearchSyntaxParser.STRING) |
            (1 << SearchSyntaxParser.IP) |
            (1 << SearchSyntaxParser.WORD))) !==
          0
      ) {
        this.state = 104;
        localctx._fieldMatchFunctionArg = this.fieldMatchFunctionArg();
        localctx.args.push(localctx._fieldMatchFunctionArg);
        this.state = 115;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while (_la === SearchSyntaxParser.COMMA) {
          this.state = 105;
          this.match(SearchSyntaxParser.COMMA);
          this.state = 109;
          this._errHandler.sync(this);
          _la = this._input.LA(1);
          while (_la === SearchSyntaxParser.WS) {
            this.state = 106;
            this.match(SearchSyntaxParser.WS);
            this.state = 111;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
          }
          this.state = 112;
          localctx._fieldMatchFunctionArg = this.fieldMatchFunctionArg();
          localctx.args.push(localctx._fieldMatchFunctionArg);
          this.state = 117;
          this._errHandler.sync(this);
          _la = this._input.LA(1);
        }
      }

      this.state = 120;
      this.match(SearchSyntaxParser.CLOSE_PAR);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  fieldMatchFunctionArg() {
    const localctx = new FieldMatchFunctionArgContext(
      this,
      this._ctx,
      this.state
    );
    this.enterRule(localctx, 16, SearchSyntaxParser.RULE_fieldMatchFunctionArg);
    try {
      this.state = 125;
      this._errHandler.sync(this);
      switch (this._input.LA(1)) {
        case SearchSyntaxParser.STRING:
          this.enterOuterAlt(localctx, 1);
          this.state = 122;
          this.string();
          break;
        case SearchSyntaxParser.WORD:
          this.enterOuterAlt(localctx, 2);
          this.state = 123;
          this.word();
          break;
        case SearchSyntaxParser.IP:
          this.enterOuterAlt(localctx, 3);
          this.state = 124;
          this.ip();
          break;
        default:
          throw new antlr4.error.NoViableAltException(this);
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  fieldComparison() {
    const localctx = new FieldComparisonContext(this, this._ctx, this.state);
    this.enterRule(localctx, 18, SearchSyntaxParser.RULE_fieldComparison);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 127;
      this.fieldMatch();
      this.state = 128;
      this.match(SearchSyntaxParser.COMPARATOR);
      this.state = 129;
      this.comparable();
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  value() {
    const localctx = new ValueContext(this, this._ctx, this.state);
    this.enterRule(localctx, 20, SearchSyntaxParser.RULE_value);
    try {
      this.state = 136;
      this._errHandler.sync(this);
      switch (this._input.LA(1)) {
        case SearchSyntaxParser.DATE:
          this.enterOuterAlt(localctx, 1);
          this.state = 131;
          this.date();
          break;
        case SearchSyntaxParser.NUMBER:
          this.enterOuterAlt(localctx, 2);
          this.state = 132;
          this.number();
          break;
        case SearchSyntaxParser.WORD:
          this.enterOuterAlt(localctx, 3);
          this.state = 133;
          this.word();
          break;
        case SearchSyntaxParser.STRING:
          this.enterOuterAlt(localctx, 4);
          this.state = 134;
          this.string();
          break;
        case SearchSyntaxParser.IP:
          this.enterOuterAlt(localctx, 5);
          this.state = 135;
          this.ip();
          break;
        default:
          throw new antlr4.error.NoViableAltException(this);
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  comparable() {
    const localctx = new ComparableContext(this, this._ctx, this.state);
    this.enterRule(localctx, 22, SearchSyntaxParser.RULE_comparable);
    try {
      this.state = 142;
      this._errHandler.sync(this);
      const la_ = this._interp.adaptivePredict(this._input, 13, this._ctx);
      switch (la_) {
        case 1:
          this.enterOuterAlt(localctx, 1);
          this.state = 138;
          this.date();
          break;

        case 2:
          this.enterOuterAlt(localctx, 2);
          this.state = 139;
          this.dateTimeExpr();
          break;

        case 3:
          this.enterOuterAlt(localctx, 3);
          this.state = 140;
          this.number();
          break;

        case 4:
          this.enterOuterAlt(localctx, 4);
          this.state = 141;
          this.string();
          break;
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  dateTimeExpr() {
    const localctx = new DateTimeExprContext(this, this._ctx, this.state);
    this.enterRule(localctx, 24, SearchSyntaxParser.RULE_dateTimeExpr);
    let _la = 0; // Token type
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 144;
      this.dateTime();
      this.state = 148;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
      while (
        _la === SearchSyntaxParser.DATETIME_MATH ||
        _la === SearchSyntaxParser.DATETIME_ROUNDER
      ) {
        this.state = 145;
        this.dateTimeOperation();
        this.state = 150;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  dateTimeOperation() {
    const localctx = new DateTimeOperationContext(this, this._ctx, this.state);
    this.enterRule(localctx, 26, SearchSyntaxParser.RULE_dateTimeOperation);
    try {
      this.state = 153;
      this._errHandler.sync(this);
      switch (this._input.LA(1)) {
        case SearchSyntaxParser.DATETIME_ROUNDER:
          this.enterOuterAlt(localctx, 1);
          this.state = 151;
          this.dateTimeRound();
          break;
        case SearchSyntaxParser.DATETIME_MATH:
          this.enterOuterAlt(localctx, 2);
          this.state = 152;
          this.dateTimeMath();
          break;
        default:
          throw new antlr4.error.NoViableAltException(this);
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  date() {
    const localctx = new DateContext(this, this._ctx, this.state);
    this.enterRule(localctx, 28, SearchSyntaxParser.RULE_date);
    let _la = 0; // Token type
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 155;
      this.match(SearchSyntaxParser.DATE);
      this.state = 157;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
      if (_la === SearchSyntaxParser.TIMEZONE) {
        this.state = 156;
        this.match(SearchSyntaxParser.TIMEZONE);
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  dateTime() {
    const localctx = new DateTimeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 30, SearchSyntaxParser.RULE_dateTime);
    let _la = 0; // Token type
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 159;
      _la = this._input.LA(1);
      if (
        !(
          (_la & ~0x1f) == 0 &&
          ((1 << _la) &
            ((1 << SearchSyntaxParser.DATETIME_FN) |
              (1 << SearchSyntaxParser.DATE) |
              (1 << SearchSyntaxParser.DATETIME))) !==
            0
        )
      ) {
        this._errHandler.recoverInline(this);
      } else {
        this._errHandler.reportMatch(this);
        this.consume();
      }
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  dateTimeRound() {
    const localctx = new DateTimeRoundContext(this, this._ctx, this.state);
    this.enterRule(localctx, 32, SearchSyntaxParser.RULE_dateTimeRound);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 161;
      this.match(SearchSyntaxParser.DATETIME_ROUNDER);
      this.state = 162;
      this.match(SearchSyntaxParser.DATETIME_UNIT);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  dateTimeMath() {
    const localctx = new DateTimeMathContext(this, this._ctx, this.state);
    this.enterRule(localctx, 34, SearchSyntaxParser.RULE_dateTimeMath);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 164;
      this.match(SearchSyntaxParser.DATETIME_MATH);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  number() {
    const localctx = new NumberContext(this, this._ctx, this.state);
    this.enterRule(localctx, 36, SearchSyntaxParser.RULE_number);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 166;
      this.match(SearchSyntaxParser.NUMBER);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  string() {
    const localctx = new StringContext(this, this._ctx, this.state);
    this.enterRule(localctx, 38, SearchSyntaxParser.RULE_string);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 168;
      this.match(SearchSyntaxParser.STRING);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  word() {
    const localctx = new WordContext(this, this._ctx, this.state);
    this.enterRule(localctx, 40, SearchSyntaxParser.RULE_word);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 170;
      this.match(SearchSyntaxParser.WORD);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  ip() {
    const localctx = new IpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 42, SearchSyntaxParser.RULE_ip);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 172;
      this.match(SearchSyntaxParser.IP);
    } catch (re) {
      if (re instanceof antlr4.error.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }
}

SearchSyntaxParser.EOF = antlr4.Token.EOF;
SearchSyntaxParser.NEGATION = 1;
SearchSyntaxParser.OPEN_PAR = 2;
SearchSyntaxParser.CLOSE_PAR = 3;
SearchSyntaxParser.COMMA = 4;
SearchSyntaxParser.NULL = 5;
SearchSyntaxParser.DATETIME_FN = 6;
SearchSyntaxParser.DATETIME_MATH = 7;
SearchSyntaxParser.DATETIME_UNIT = 8;
SearchSyntaxParser.FIELD_MATCH = 9;
SearchSyntaxParser.DATE = 10;
SearchSyntaxParser.DATETIME = 11;
SearchSyntaxParser.DATETIME_ROUNDER = 12;
SearchSyntaxParser.TIMEZONE = 13;
SearchSyntaxParser.COMPARATOR = 14;
SearchSyntaxParser.RANGE_OP = 15;
SearchSyntaxParser.NUMBER = 16;
SearchSyntaxParser.DECIMAL = 17;
SearchSyntaxParser.INTEGER = 18;
SearchSyntaxParser.STRING = 19;
SearchSyntaxParser.IP = 20;
SearchSyntaxParser.WORD = 21;
SearchSyntaxParser.MATCH_OP = 22;
SearchSyntaxParser.WS = 23;

SearchSyntaxParser.RULE_query = 0;
SearchSyntaxParser.RULE_expression = 1;
SearchSyntaxParser.RULE_field = 2;
SearchSyntaxParser.RULE_fieldMatch = 3;
SearchSyntaxParser.RULE_fieldMatchRange = 4;
SearchSyntaxParser.RULE_fieldMatchValue = 5;
SearchSyntaxParser.RULE_fieldMatchNull = 6;
SearchSyntaxParser.RULE_fieldMatchFunction = 7;
SearchSyntaxParser.RULE_fieldMatchFunctionArg = 8;
SearchSyntaxParser.RULE_fieldComparison = 9;
SearchSyntaxParser.RULE_value = 10;
SearchSyntaxParser.RULE_comparable = 11;
SearchSyntaxParser.RULE_dateTimeExpr = 12;
SearchSyntaxParser.RULE_dateTimeOperation = 13;
SearchSyntaxParser.RULE_date = 14;
SearchSyntaxParser.RULE_dateTime = 15;
SearchSyntaxParser.RULE_dateTimeRound = 16;
SearchSyntaxParser.RULE_dateTimeMath = 17;
SearchSyntaxParser.RULE_number = 18;
SearchSyntaxParser.RULE_string = 19;
SearchSyntaxParser.RULE_word = 20;
SearchSyntaxParser.RULE_ip = 21;

export class QueryContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_query;
  }

  EOF() {
    return this.getToken(SearchSyntaxParser.EOF, 0);
  }

  WS = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTokens(SearchSyntaxParser.WS);
    } else {
      return this.getToken(SearchSyntaxParser.WS, i);
    }
  };

  expression = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTypedRuleContexts(ExpressionContext);
    } else {
      return this.getTypedRuleContext(ExpressionContext, i);
    }
  };

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitQuery(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class ExpressionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_expression;
  }

  field() {
    return this.getTypedRuleContext(FieldContext, 0);
  }

  string() {
    return this.getTypedRuleContext(StringContext, 0);
  }

  word() {
    return this.getTypedRuleContext(WordContext, 0);
  }

  ip() {
    return this.getTypedRuleContext(IpContext, 0);
  }

  NEGATION() {
    return this.getToken(SearchSyntaxParser.NEGATION, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class FieldContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_field;
  }

  fieldMatchRange() {
    return this.getTypedRuleContext(FieldMatchRangeContext, 0);
  }

  fieldMatchValue() {
    return this.getTypedRuleContext(FieldMatchValueContext, 0);
  }

  fieldComparison() {
    return this.getTypedRuleContext(FieldComparisonContext, 0);
  }

  fieldMatchNull() {
    return this.getTypedRuleContext(FieldMatchNullContext, 0);
  }

  fieldMatchFunction() {
    return this.getTypedRuleContext(FieldMatchFunctionContext, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitField(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class FieldMatchContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_fieldMatch;
  }

  FIELD_MATCH() {
    return this.getToken(SearchSyntaxParser.FIELD_MATCH, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitFieldMatch(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class FieldMatchRangeContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_fieldMatchRange;
  }

  fieldMatch() {
    return this.getTypedRuleContext(FieldMatchContext, 0);
  }

  comparable = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTypedRuleContexts(ComparableContext);
    } else {
      return this.getTypedRuleContext(ComparableContext, i);
    }
  };

  RANGE_OP() {
    return this.getToken(SearchSyntaxParser.RANGE_OP, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitFieldMatchRange(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class FieldMatchValueContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_fieldMatchValue;
  }

  fieldMatch() {
    return this.getTypedRuleContext(FieldMatchContext, 0);
  }

  value() {
    return this.getTypedRuleContext(ValueContext, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitFieldMatchValue(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class FieldMatchNullContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_fieldMatchNull;
  }

  fieldMatch() {
    return this.getTypedRuleContext(FieldMatchContext, 0);
  }

  NULL() {
    return this.getToken(SearchSyntaxParser.NULL, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitFieldMatchNull(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class FieldMatchFunctionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_fieldMatchFunction;
    this.functionName = null; // WordContext
    this._fieldMatchFunctionArg = null; // FieldMatchFunctionArgContext
    this.args = []; // of FieldMatchFunctionArgContexts
  }

  fieldMatch() {
    return this.getTypedRuleContext(FieldMatchContext, 0);
  }

  OPEN_PAR() {
    return this.getToken(SearchSyntaxParser.OPEN_PAR, 0);
  }

  CLOSE_PAR() {
    return this.getToken(SearchSyntaxParser.CLOSE_PAR, 0);
  }

  word() {
    return this.getTypedRuleContext(WordContext, 0);
  }

  fieldMatchFunctionArg = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTypedRuleContexts(FieldMatchFunctionArgContext);
    } else {
      return this.getTypedRuleContext(FieldMatchFunctionArgContext, i);
    }
  };

  COMMA = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTokens(SearchSyntaxParser.COMMA);
    } else {
      return this.getToken(SearchSyntaxParser.COMMA, i);
    }
  };

  WS = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTokens(SearchSyntaxParser.WS);
    } else {
      return this.getToken(SearchSyntaxParser.WS, i);
    }
  };

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitFieldMatchFunction(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class FieldMatchFunctionArgContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_fieldMatchFunctionArg;
  }

  string() {
    return this.getTypedRuleContext(StringContext, 0);
  }

  word() {
    return this.getTypedRuleContext(WordContext, 0);
  }

  ip() {
    return this.getTypedRuleContext(IpContext, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitFieldMatchFunctionArg(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class FieldComparisonContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_fieldComparison;
  }

  fieldMatch() {
    return this.getTypedRuleContext(FieldMatchContext, 0);
  }

  COMPARATOR() {
    return this.getToken(SearchSyntaxParser.COMPARATOR, 0);
  }

  comparable() {
    return this.getTypedRuleContext(ComparableContext, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitFieldComparison(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class ValueContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_value;
  }

  date() {
    return this.getTypedRuleContext(DateContext, 0);
  }

  number() {
    return this.getTypedRuleContext(NumberContext, 0);
  }

  word() {
    return this.getTypedRuleContext(WordContext, 0);
  }

  string() {
    return this.getTypedRuleContext(StringContext, 0);
  }

  ip() {
    return this.getTypedRuleContext(IpContext, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitValue(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class ComparableContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_comparable;
  }

  date() {
    return this.getTypedRuleContext(DateContext, 0);
  }

  dateTimeExpr() {
    return this.getTypedRuleContext(DateTimeExprContext, 0);
  }

  number() {
    return this.getTypedRuleContext(NumberContext, 0);
  }

  string() {
    return this.getTypedRuleContext(StringContext, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitComparable(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class DateTimeExprContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_dateTimeExpr;
  }

  dateTime() {
    return this.getTypedRuleContext(DateTimeContext, 0);
  }

  dateTimeOperation = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTypedRuleContexts(DateTimeOperationContext);
    } else {
      return this.getTypedRuleContext(DateTimeOperationContext, i);
    }
  };

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitDateTimeExpr(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class DateTimeOperationContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_dateTimeOperation;
  }

  dateTimeRound() {
    return this.getTypedRuleContext(DateTimeRoundContext, 0);
  }

  dateTimeMath() {
    return this.getTypedRuleContext(DateTimeMathContext, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitDateTimeOperation(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class DateContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_date;
  }

  DATE() {
    return this.getToken(SearchSyntaxParser.DATE, 0);
  }

  TIMEZONE() {
    return this.getToken(SearchSyntaxParser.TIMEZONE, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitDate(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class DateTimeContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_dateTime;
  }

  DATETIME() {
    return this.getToken(SearchSyntaxParser.DATETIME, 0);
  }

  DATE() {
    return this.getToken(SearchSyntaxParser.DATE, 0);
  }

  DATETIME_FN() {
    return this.getToken(SearchSyntaxParser.DATETIME_FN, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitDateTime(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class DateTimeRoundContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_dateTimeRound;
  }

  DATETIME_ROUNDER() {
    return this.getToken(SearchSyntaxParser.DATETIME_ROUNDER, 0);
  }

  DATETIME_UNIT() {
    return this.getToken(SearchSyntaxParser.DATETIME_UNIT, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitDateTimeRound(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class DateTimeMathContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_dateTimeMath;
  }

  DATETIME_MATH() {
    return this.getToken(SearchSyntaxParser.DATETIME_MATH, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitDateTimeMath(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class NumberContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_number;
  }

  NUMBER() {
    return this.getToken(SearchSyntaxParser.NUMBER, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitNumber(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class StringContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_string;
  }

  STRING() {
    return this.getToken(SearchSyntaxParser.STRING, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitString(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class WordContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_word;
  }

  WORD() {
    return this.getToken(SearchSyntaxParser.WORD, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitWord(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

export class IpContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = SearchSyntaxParser.RULE_ip;
  }

  IP() {
    return this.getToken(SearchSyntaxParser.IP, 0);
  }

  accept(visitor) {
    if (visitor instanceof SearchSyntaxVisitor) {
      return visitor.visitIp(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

SearchSyntaxParser.QueryContext = QueryContext;
SearchSyntaxParser.ExpressionContext = ExpressionContext;
SearchSyntaxParser.FieldContext = FieldContext;
SearchSyntaxParser.FieldMatchContext = FieldMatchContext;
SearchSyntaxParser.FieldMatchRangeContext = FieldMatchRangeContext;
SearchSyntaxParser.FieldMatchValueContext = FieldMatchValueContext;
SearchSyntaxParser.FieldMatchNullContext = FieldMatchNullContext;
SearchSyntaxParser.FieldMatchFunctionContext = FieldMatchFunctionContext;
SearchSyntaxParser.FieldMatchFunctionArgContext = FieldMatchFunctionArgContext;
SearchSyntaxParser.FieldComparisonContext = FieldComparisonContext;
SearchSyntaxParser.ValueContext = ValueContext;
SearchSyntaxParser.ComparableContext = ComparableContext;
SearchSyntaxParser.DateTimeExprContext = DateTimeExprContext;
SearchSyntaxParser.DateTimeOperationContext = DateTimeOperationContext;
SearchSyntaxParser.DateContext = DateContext;
SearchSyntaxParser.DateTimeContext = DateTimeContext;
SearchSyntaxParser.DateTimeRoundContext = DateTimeRoundContext;
SearchSyntaxParser.DateTimeMathContext = DateTimeMathContext;
SearchSyntaxParser.NumberContext = NumberContext;
SearchSyntaxParser.StringContext = StringContext;
SearchSyntaxParser.WordContext = WordContext;
SearchSyntaxParser.IpContext = IpContext;
